import { render } from "./Unsubscribe.vue?vue&type=template&id=fdef12e0"
import script from "./Unsubscribe.vue?vue&type=script&lang=js"
export * from "./Unsubscribe.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__